import React from "react";
import { Col, Container, Row, Tab, Nav } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";
import { Link } from "gatsby";

function Redefinepatientservices() {
  return (
    <section className="redefinepatient_services p-100 tekgrip_section cloud_services">
      <Container>
        <Row>
          <Col xs={12} md={9} lg={8} xl={8} xxl={8}>
            <h2>Our Cloud Deployment Expertise</h2>
            <p>
              Empower your startup, scale-up, or enterprise with our expert
              Cloud Consultancy Services for optimized performance, security,
              and scalability across diverse cloud environments.
            </p>
            <Link
              to="/contact"
              className="border_btn"
              aria-label="TekRevol Contact"
            >
               Request a Consultation
            </Link>
          </Col>
        </Row>
        <Row className="mt-lg-5 mt-md-3 md-sm-2">
          <Col
            xs={12}
            md={12}
            lg={12}
            xl={12}
            xxl={12}
            className="tekgrip_tabs"
          >
            <Col xs={12} md={12} lg={12} xl={12} xxl={12}>
              <Tab.Container id="" defaultActiveKey="0">
                <Row>
                  <Col xs={12} md={6} lg={6} xl={6} className="redefine_tabs">
                    <Nav variant="pills" className="flex-column">
                      <div className="red_item">
                        <Nav.Item>
                          <Nav.Link eventKey="0">
                            01. Public Cloud Consulting Services
                          </Nav.Link>
                        </Nav.Item>
                        <Nav.Item>
                          <Nav.Link eventKey="1">
                            02. Private Cloud Consulting Services
                          </Nav.Link>
                        </Nav.Item>
                        <Nav.Item>
                          <Nav.Link eventKey="2">
                            03. Hybrid Cloud Strategy Services
                          </Nav.Link>
                        </Nav.Item>
                        <Nav.Item>
                          <Nav.Link eventKey="3">
                            04. Multi-Cloud Strategy Services Services
                          </Nav.Link>
                        </Nav.Item>
                      </div>
                    </Nav>
                  </Col>
                  <Col xs={12} md={6} lg={6} xl={6} className="p-0">
                    <Tab.Content>
                      <Tab.Pane eventKey="0">
                        <div className="redefine_tabs_img">
                          <StaticImage
                            src="../../images/services-usa/cloud-new/public_cloud.webp"
                            alt="TekRevol"
                            layout="constrained"
                            placeholder="blurred"
                            formats={["webp"]}
                            width={48}
                            height={48}
                          />
                        </div>
                        <h3>Public Cloud Consulting Services</h3>
                        <p>
                          Expert guidance on leveraging public cloud platforms
                          like AWS, Azure, and GCP for optimal performance and
                          cost-efficiency.
                        </p>
                      </Tab.Pane>
                      <Tab.Pane eventKey="1">
                        <div className="redefine_tabs_img">
                          <StaticImage
                            src="../../images/services-usa/cloud-new/private_cloud.webp"
                            alt="TekRevol"
                            layout="constrained"
                            placeholder="blurred"
                            formats={["webp"]}
                            width={48}
                            height={48}
                          />
                        </div>
                        <h3>Private Cloud Consulting Services</h3>
                        <p>
                          Tailored recommendations for setting up and managing
                          private cloud infrastructures, ensuring security and
                          compliance.
                        </p>
                      </Tab.Pane>
                      <Tab.Pane eventKey="2">
                        <div className="redefine_tabs_img">
                          <StaticImage
                            src="../../images/services-usa/cloud-new/hybrid_cloud.webp"
                            alt="TekRevol"
                            layout="constrained"
                            placeholder="blurred"
                            formats={["webp"]}
                            width={48}
                            height={48}
                          />
                        </div>
                        <h3>Hybrid Cloud Strategy Services</h3>
                        <p>
                          Strategic planning for integrating on-premises and
                          cloud environments seamlessly, optimizing resource
                          utilization and scalability.
                        </p>
                      </Tab.Pane>
                      <Tab.Pane eventKey="3">
                        <div className="redefine_tabs_img">
                          <StaticImage
                            src="../../images/services-usa/cloud-new/multi_cloud.webp"
                            alt="TekRevol"
                            layout="constrained"
                            placeholder="blurred"
                            formats={["webp"]}
                            width={48}
                            height={48}
                          />
                        </div>
                        <h3>Multi-Cloud Strategy Services</h3>
                        <p>
                          Develop comprehensive strategies for leveraging
                          multiple cloud providers, ensuring flexibility,
                          redundancy, and performance across platforms.
                        </p>
                      </Tab.Pane>
                    </Tab.Content>
                  </Col>
                </Row>
              </Tab.Container>
            </Col>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Redefinepatientservices;
